import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ProgressBar from '../components/ProgressBar';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import Tile from '../components/common/Tile';
import TopInstructionAndLink from '../components/TopInstructionAndLink';
import { WardrobeHeightContext } from '../contexts/WardrobeHeightContext';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';
import { getFrontsByType } from '../store/actions/products';
import Loader from '../components/Loader';
import { GAContext } from 'contexts/GAContext';

const WardrobeTypeSelection = props => {
  const history = useHistory();
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobeHulls, cornerHulls, defaultHull, defaultCorner, defaultFront } = props;
  const { wardrobeHeight } = useContext(WardrobeHeightContext);
  const { GA } = useContext(GAContext);

  const isHight = wardrobeHeight === 240;

  const setWardrobeType = wardrobeType => {
    let wardrobeHull;
    let wardrobes = [...wardrobesConfigs];

    const wardrobeHullsList = wardrobeType === 'corner' ? cornerHulls : wardrobeHulls;

    let filteredData = [...wardrobeHullsList];
    const defaultHullInfo = defaultHull[7] ?? {};

    if (wardrobeType === 'corner') {
      wardrobeHull = filteredData.find(item => {
        return (
          item.safo.split('-').pop() === defaultHullInfo.colorName &&
          item.dimensions.y === wardrobeHeight &&
          item.types.hasOwnProperty(defaultCorner.type)
        );
      });
    }

    if (wardrobeType === 'wardrobe' || wardrobeType === 'wardrobe-hinged') {
      defaultHullInfo.dimensions.y = wardrobeHeight;
      const width = wardrobeType === 'wardrobe-hinged' ? 100 : defaultHullInfo.dimensions.x;

      filteredData = filteredData.filter(item => {
        return (
          item.dimensions.x === width &&
          item.dimensions.y === defaultHullInfo.dimensions.y &&
          item.dimensions.z === defaultHullInfo.dimensions.z
        );
      });

      wardrobeHull = filteredData.find(item => {
        return item.safo.split('-').pop() === defaultHullInfo.colorName;
      });
    }

    if (wardrobeHull !== undefined) {
      let hullType = !wardrobeHull.is_hinged ? 7 : 8;
      let defaultFrontInfo = defaultFront[hullType];

      wardrobeHull.defaultFronts = !wardrobeHull.is_hinged
        ? defaultFrontInfo[wardrobeHull.panels] ?? []
        : defaultFrontInfo;
      wardrobes[activeWardrobe] = wardrobeHull;
      setWardrobesConfigs(wardrobes);
      history.push('/wardrobe-body-configuration');
    }
    GA('Wardrobe Type', 'Select type of wardrobe');
  };

  return (
    <div className="wardrobe-type">
      {!!wardrobeHulls && !!cornerHulls && (
        <>
          <div className="container wardrobe-type__top">
            <ProgressBar link="/height-settings" activeLvl={0} />
            <TopInstructionAndLink text="Wybierz rodzaj szafy" />
          </div>
          {cornerHulls.length !== 0 && wardrobeHulls.length !== 0 ? (
            <div className="wardrobe-type__box">
              <div
                className="wardrobe-type__tile-container"
                onClick={() => setWardrobeType('wardrobe')}>
                <Tile
                  img={`${process.env.PUBLIC_URL}/img/wardrobe${isHight ? '' : '_small'}.png`}
                  mainText="Szafa przesuwna"
                />
              </div>
              <div
                className="wardrobe-type__tile-container"
                onClick={() => setWardrobeType('wardrobe-hinged')}>
                <Tile
                  img={`${process.env.PUBLIC_URL}/img/wardrobe-hinged.png`}
                  mainText="Szafa uchylna"
                />
              </div>
              <div
                className="wardrobe-type__tile-container"
                onClick={() => setWardrobeType('corner')}>
                <Tile
                  img={`${process.env.PUBLIC_URL}/img/corner-wardrobe${
                    isHight ? '' : '_small'
                  }.png`}
                  mainText="Szafa narożna"
                />
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    wardrobeHulls: state.products.wardrobeHulls,
    cornerHulls: state.products.cornerHulls,
    bodyColorList: state.products.bodyColors,
    dimensions: state.dimensions.dimensions,
    defaultHull: state.defaults.hull,
    defaultCorner: state.defaults.corner,
    defaultFront: state.defaults.front,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFrontsByType: (wardrobeType, activeDimensions) =>
      dispatch(getFrontsByType(wardrobeType, activeDimensions)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WardrobeTypeSelection);
